import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Error from "./pages/Error";
import SharedLayout from "./pages/SharedLayout";
import ScrollToTop from "./components/ScrollToTop"; 
import { Suspense } from "react";
const LazyAbout = React.lazy(() => import('./pages/About'));
const LazySedacky = React.lazy(() => import('./pages/Couches'));
const LazyCouch = React.lazy(() => import('./components/Couch'));
const LazyPart = React.lazy(() => import('./components/CouchPart'));
const LazyGallery = React.lazy(() => import('./components/Gallery2'));
const LazyKontakt = React.lazy(() => import('./pages/Contact'));
const LazyStock = React.lazy(() => import('./pages/Stock'));
const LazyStockItem = React.lazy(() => import('./components/StockItem'));
const LazyFurniture = React.lazy(() => import('./pages/Furniture'));
const LazyFurnitureItem = React.lazy(() => import('./components/FurnitureItem'));

function Loading() {
  return <div></div>;
}

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<SharedLayout />}>
            <Route index element={<Home />} />
            {/*<Route path="Onas" element={<LazyAbout />} />*/}
              <Route path="Sedacky" element={<LazySedacky />} ></Route>
              <Route path="Sedacky/:category" element={<LazySedacky />} />
              <Route path="Sedacky/:category/:couchTitle" element={<LazyCouch />} />
              <Route path="Sedacky/:category/:couchTitle/:partTitle" element={<LazyPart />} /> 
              <Route path="Kontakt" element={<LazyKontakt />}/>
              <Route path="Vzorkovniky" element={<LazyGallery />}/>
              <Route path="Ihned-k-odberu" element={<LazyStock />}/>
              <Route path="Ihned-k-odberu/:category" element={<LazyStock />}/>
              <Route path="Ihned-k-odberu/:category/:couchTitle" element={<LazyStockItem />}/>
              <Route path="Nabytok" element={<LazyFurniture />}/>
              <Route path="Nabytok/:category" element={<LazyFurniture />}/>
              <Route path="Nabytok/:category/:couchTitle" element={<LazyFurnitureItem />}/>
            </Route>
          <Route path="*" element={<Error />} />
        </Routes></Suspense>
    </BrowserRouter>
  );
};


export default App